import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from '@fortawesome/free-solid-svg-icons';

Object.keys(icons).forEach(i => {
	if (icons[i].iconName) {
		library.add(icons[i]);
	}
});